import React from "react";
import LoadingScreen from "../../../utils/LoadingScreen";

const WalletTransactionModal = ({
  show,
  onClose,
  data = [],
  loading,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  onFetch,
}) => {

    const toNum = (v) => Number(v || 0);

const formatINR = (v) => `₹ ${toNum(v).toFixed(2)}`;

const totals = data.reduce(
  (acc, item) => {
    const credit = toNum(item.settelment_value);
    const debit =
      toNum(item.chaafoCommission) +
      toNum(item.taxOnCommission) +
      toNum(item.delivery_charges) +
      toNum(item.packaging_charges);

    acc.credit += credit;
    acc.debit += debit;

    return acc;
  },
  { credit: 0, debit: 0 }
);

  if (!show) return null;

  return (
    <>
   
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 montserrat-font-1"
         onClick={onClose}>
      <div className="bg-white w-[900px] rounded-lg shadow-lg montserrat-font-1"
  onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="flex justify-between items-center px-4 py-3 border-b">
          <h2 className="text-lg font-semibold">
            Wallet Transaction Details
          </h2>
          <button onClick={onClose}>✕</button>
        </div>

        {/* Filters */}
        <div className="flex items-center gap-3 px-4 py-3">
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            className="border px-2 py-1 rounded"
          />
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            className="border px-2 py-1 rounded"
          />
          <button
            onClick={onFetch}
            className="bg-blue-600 text-white px-4 py-1 rounded"
          >
            Apply
          </button>
        </div>
<div className="flex justify-between items-center px-4 pb-2">
  
  {/* Left empty */}
  <div></div>

  {/* Right totals */}
  <div className="text-sm font-semibold flex gap-4">
    <h1 className="">Totals:</h1>
    <span className="text-green-600">
      Credit: {formatINR(totals.credit)}
    </span>
    <span className="text-red-600">
      Debit: {formatINR(totals.debit)}
    </span>
  </div>

</div>

        {/* Table */}
        <div className="max-h-[400px] overflow-y-auto px-4 pb-4 montserrat-font-1">
          <table className="w-full text-sm montserrat-font-1">
            <thead className="border-b bg-green-100 montserrat-font-1">
              <tr>
                <th className="text-left py-2 px-2">Date / Order</th>
                <th className="text-center px-2">Type</th>
                <th className="text-center px-2">Amount</th>
                <th className="text-right px-2">Credited</th>
              </tr>
            </thead>

          <tbody>
  {loading ? (
    <tr>
      <td colSpan="4" className="text-center py-10">
        <LoadingScreen text="Loading..." />
      </td>
    </tr>
  ) : data.length === 0 ? (
    <tr>
      <td colSpan="4" className="text-center py-6 text-gray-500">
        No Data Found
      </td>
    </tr>
  ) : (
    data.map((item, i) => {
  const commission = toNum(item.chaafoCommission);
  const tax = toNum(item.taxOnCommission);
  const delivery = toNum(item.delivery_charges);
  const packaging = toNum(item.packaging_charges);

  const deductions = [];

  if (commission > 0) deductions.push(`Commission ₹${commission}`);
  if (tax > 0) deductions.push(`Tax ₹${tax}`);
  if (delivery > 0) deductions.push(`Delivery ₹${delivery}`);
  if (packaging > 0) deductions.push(`Packaging ₹${packaging}`);

  return (
    <tr key={i} className="border-b">

      {/* Date + Order */}
      <td className="py-2 px-2">
        <div className="font-semibold">{item.in_date}</div>
        <div className="text-xs text-gray-500">
          Order #{item.orderid}
        </div>
      </td>

      {/* Type */}
      <td className="text-center px-2">
        <span className="bg-gray-100 px-2 py-1 rounded text-xs capitalize">
          {item.order_type}
        </span>
      </td>

      {/* Amount */}
      <td className="text-center px-2">
        <div className="font-semibold">
          {formatINR(item.order_amount)}
        </div>

        {deductions.length > 0 && (
          <div className="text-xs text-gray-500 mt-1">
            − {deductions.join(" · ")}
          </div>
        )}
      </td>

      {/* Credited */}
      <td className="text-right text-green-600 font-semibold px-2">
        {formatINR(item.settelment_value)}
      </td>

    </tr>
  );
})
  )}
</tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="flex justify-end px-4 py-3 border-t">
          <button
            onClick={onClose}
            className="bg-gray-500 text-white px-4 py-2 rounded"
          >
            Close
          </button>
        </div>

      </div>
    </div>
    </>
  );
};

export default WalletTransactionModal;